import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OnlinePredictionIcon(props: IconProps) {
    return <Icon {...props} iconKey={"online_prediction"}/>
}
